
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHesabePaymentCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeMerchantCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeAccessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeSecretKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeIvKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeUseSandbox"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hesabeDirectPayment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeMerchantCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeMerchantCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeAccessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeAccessCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeSecretKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeSecretKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeIvKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeIvKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeUseSandbox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeUseSandbox"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hesabeDirectPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hesabeDirectPayment"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGatewayCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeMerchantCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeAccessCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeSecretKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeIvKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeUseSandbox"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hesabeDirectPayment"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":667}};
    doc.loc.source = {"body":"mutation updateHesabePaymentCredentials(\n  $hesabeMerchantCode: String\n  $hesabeAccessCode: String\n  $hesabeSecretKey: String\n  $hesabeIvKey: String\n  $hesabeUseSandbox: Boolean\n  $hesabeDirectPayment: Boolean\n) {\n  updateConfigurations(\n    input: {\n      hesabeMerchantCode: $hesabeMerchantCode\n      hesabeAccessCode: $hesabeAccessCode\n      hesabeSecretKey: $hesabeSecretKey\n      hesabeIvKey: $hesabeIvKey\n      hesabeUseSandbox: $hesabeUseSandbox\n      hesabeDirectPayment: $hesabeDirectPayment\n    }\n  ) {\n    paymentGatewayCode\n    hesabeMerchantCode\n    hesabeAccessCode\n    hesabeSecretKey\n    hesabeIvKey\n    hesabeUseSandbox\n    hesabeDirectPayment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateHesabePaymentCredentials"] = oneQuery(doc, "updateHesabePaymentCredentials");
        
